import { hotTop, riseItems } from "../../../mocks/portalData";

export default function HotRank() {
  const trendIcon = (trend: string) => {
    if (trend === "peak") return "ri-fire-fill text-primary-500";
    if (trend === "up") return "ri-arrow-up-line text-primary-500";
    if (trend === "down") return "ri-arrow-down-line text-accent-600";
    return "ri-subtract-line text-foreground-400";
  };

  return (
    <section id="hot" className="w-full border-y border-background-200/70 bg-background-100">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-10 md:px-6 md:py-14">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="h-4 w-1 rounded-full bg-primary-500"></span>
            <h3 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">全网热榜</h3>
            <span className="ml-1 rounded-full bg-primary-100 px-2.5 py-0.5 text-xs font-bold text-primary-700">
              实时 · 每小时更新
            </span>
          </div>
          <a href="#catalog" className="hidden items-center gap-1 whitespace-nowrap text-xs font-bold text-foreground-600 hover:text-foreground-950 sm:flex">
            榜单说明
            <i className="ri-question-line text-sm"></i>
          </a>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_340px]">
          {/* TOP list */}
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <ol className="divide-y divide-background-200">
              {hotTop.map((item, idx) => (
                <li key={item.rank}>
                  <a href="#flow" className="group flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-100 md:gap-4 md:px-5">
                    <span
                      className={
                        "flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-sm font-black " +
                        (idx < 3 ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600")
                      }
                    >
                      {String(item.rank).padStart(2, "0")}
                    </span>
                    <span className="min-w-0 flex-1 truncate text-sm font-bold text-foreground-950 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </span>
                    <span className="hidden whitespace-nowrap rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-800 md:inline-block">
                      {item.tag}
                    </span>
                    <span className="flex items-center gap-1 whitespace-nowrap text-xs font-black text-foreground-700">
                      <i className={trendIcon(item.trend)}></i>
                      {item.heat}
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          {/* 飙升 */}
          <aside className="flex flex-col rounded-lg border border-background-200 bg-background-50">
            <div className="flex items-center gap-2 border-b border-background-200 px-4 py-3">
              <i className="ri-flashlight-fill text-accent-500"></i>
              <h4 className="text-sm font-black text-foreground-950">72小时飙升</h4>
              <span className="ml-auto text-xs font-medium text-foreground-500">涨幅排序</span>
            </div>
            <div className="flex flex-1 flex-col justify-center gap-1 p-2">
              {riseItems.map((item, idx) => (
                <a href="#flow" key={idx} className="group flex items-start gap-3 rounded-md px-3 py-2.5 transition-colors hover:bg-background-100">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-accent-100 text-xs font-black text-accent-700">
                    {idx + 1}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-bold text-foreground-800 group-hover:text-foreground-950">{item.title}</p>
                  </div>
                  <i className="ri-arrow-up-line mt-0.5 text-xs font-black text-primary-500"></i>
                </a>
              ))}
            </div>
            <div className="border-t border-background-200 bg-background-100 px-4 py-3 text-center">
              <button type="button" className="flex w-full items-center justify-center gap-1.5 whitespace-nowrap text-xs font-bold text-primary-600">
                刷新飙升榜
                <i className="ri-refresh-line text-sm"></i>
              </button>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}